module.exports = __webpack_public_path__ + "static/media/animal-dog9.9dce297f.aac";